module.exports = __webpack_public_path__ + "img/ic_device_band.451c6ad9.png";